import React, { useContext, useEffect, useState } from "react";
import classes from "./AboutUs.module.css";
import Carousel from "./spring-carousel/Carousel";
import { v4 as uuidv4 } from "uuid";
import Card from "./spring-carousel/Card";
import CarouselTest from "./spring-carousel/CarouselTest";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import { useLocation, useNavigate } from "react-router-dom";
import AdjustFontSize from "../../../components/adjust-font-size/AdjustFontSize";
import { NavigationContext } from "../../../App";

const AboutUs = ({ data }) => {
  const [responsiveHtml, setResponsiveHtml] = useState("");
  const width = useDeviceWidth();
  const navigate = useNavigate();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

    const { setIsBackNavigation } = useContext(NavigationContext);

  // useEffect(() => {
  //   //html content will rearrange fontsize when window width changes
  //   if (data) {
  //     setResponsiveHtml(AdjustFontSize(data?.listingItems[0]?.homeDescription, width));
  //   }
  // }, [data, width]);

  let cards = [
    {
      key: uuidv4(),
      content: <Card />,
    },
    {
      key: uuidv4(),
      content: <Card />,
    },
    {
      key: uuidv4(),
      content: <Card />,
    },
    {
      key: uuidv4(),
      content: <Card />,
    },
    {
      key: uuidv4(),
      content: <Card />,
    },
  ];

  console.log("data in about us", data);

  const rawHtml =
    "<p style='color: black; font-size: 36px;font-weight: 700;'>A Legacy of Healthcare Excellence</p>";

  return (
    <>
      <div className={classes.outer} id={sessionStore}>
        <div className={`${classes.right} right-carousel`}>
          <Carousel data={data?.listingItems[0]?.images} />
          {/* <CarouselTest /> */}
        </div>
        <div className={classes.left}>
          <span className={`bg-primary-200 primary-500 ${classes.subTitle}`}>
            {data?.subTitle}
          </span>
          {data?.showTitle && (
            <div className={classes.title}>
              <h3 dangerouslySetInnerHTML={{ __html: data?.title }}></h3>
            </div>
          )}
          {/* <div className={classes.underLine}></div> */}
          {data?.description && (
            <p
              className={`${classes.description} description-content`}
              dangerouslySetInnerHTML={{
                __html: data?.listingItems[0]?.homeDescription,
              }}
            ></p>
          )}
          <button
            className="primaryHover border-primary-500"
            onClick={() => {
              const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              navigate(`/pages/${data?.listingItems[0]?.slug}`);
              setIsBackNavigation(true)
            }}
          >
            Know More About Us
          </button>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
